
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinar/[id]",
      function () {
        return require("private-next-pages/webinar/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinar/[id]"])
      });
    }
  